// @flow
export type PlainAntennaReach = {
  reachOutsideAntenna: number,
  reachInsideAntenna: number
}

export default class AntennaReach {
  reachInsideAntenna: number;
  reachOutsideAntenna: number;
  proportionInsideAntenna: number;
  proportionOutsideAntenna: number;

  constructor(
    reachInsideAntenna: number,
    reachOutsideAntenna: number,
    proportionInsideAntenna: number,
    proportionOutsideAntenna: number) {
    this.reachInsideAntenna = reachInsideAntenna;
    this.reachOutsideAntenna = reachOutsideAntenna;
    this.proportionInsideAntenna = proportionInsideAntenna;
    this.proportionOutsideAntenna = proportionOutsideAntenna;
  }

  static parse(data: PlainAntennaReach) {
    const total = data.reachInsideAntenna + data.reachOutsideAntenna;
    const proportionInsideAntenna = data.reachInsideAntenna / total;
    const proportionOutsideAntenna = data.reachOutsideAntenna / total;

    return new AntennaReach(data.reachInsideAntenna, data.reachOutsideAntenna, proportionInsideAntenna, proportionOutsideAntenna);
  }
}



// WEBPACK FOOTER //
// ./src/statsradio/domain/AntennaReach.js